import React from 'react';

import './CommunityTermsPopupContent.scss';

export default function CommunityTermsPopupContent({ onClose, onAgree }) {
  return (
    <>
      <div className="popup-header">
        <h4 className="communityTermsPopupContent-title">
          Voorwaarden van Community groepen
        </h4>

        <button className="popup-close-button" onClick={onClose}>
          &times;
        </button>
      </div>

      <div className="popup-body">
        <div className="communityTermsPopupContent">
          <div className="communityTermsPopupContent-text-wrap">
            <p className="communityTermsPopupContent-text">
              Welkom bij de zwangerenportaal community! Hier zijn een paar
              richtlijnen om te zorgen dat iedereen zich hier thuis voelt:
            </p>

            <ul className="communityTermsPopupContent-list">
              <li>
                Wees vriendelijk en respectvol tegen elkaar. Geen negativiteit,
                hatelijke opmerkingen of pestgedrag hier.
              </li>
              <li>
                Zorg ervoor dat iedereen veilig blijft. Deel geen persoonlijke
                informatie van jezelf of anderen, plaats geen schadelijke links
                of content.
              </li>
              <li>
                Houd de discussies relevant. Plaats alleen topics en reacties
                die betrekking hebben op zwangerschap en moederschap, en vermijd
                spam en off-topic berichten.
              </li>
              <li>
                Respecteer de privacy van anderen. Geen persoonlijke informatie
                delen zonder toestemming.
              </li>
              <li>
                Geef opbouwende kritiek. Geef feedback die helpt, en vermijd
                negatieve opmerkingen.
              </li>
              <li>
                Let op auteursrechten. Plaats geen content die auteursrechtelijk
                beschermd is zonder toestemming van de eigenaar.
              </li>
              <li>
                Blijf binnen de wet. Geen illegale content, discriminerende of
                beledigende berichten. Respecteer de wetten en regels van
                Nederland.
              </li>
              <li>
                Houd er rekening mee dat de adviezen van de community members
                meestal niet medisch onderbouwd zijn maar uit ervaring komen.
                Raadpleeg altijd een medische professional voordat je
                beslissingen neemt over jouw gezondheid of die van je baby.
              </li>
              <li>
                Meld problemen. Laat ons weten als er iets niet in orde is,
                zodat we actie kunnen ondernemen.
              </li>
            </ul>

            <p className="communityTermsPopupContent-text">
              Geniet ervan! De community is er om elkaar te steunen en te
              adviseren over zwangerschap en moederschap. Wees aardig voor
              elkaar en help elkaar door deze bijzondere tijd heen!
            </p>
          </div>
        </div>

        <div className="communityTermsPopupContent-divider" />

        <button
          onClick={() => onClose()}
          className="popup-button popup-button-secondary"
        >
          Annuleren
        </button>

        <button
          onClick={() => onAgree()}
          className="popup-button popup-button-primary"
        >
          Akkoord
        </button>
      </div>
    </>
  );
}
